export var IdentifierDecoratorSymbol = Symbol('$$IDENTIFIER_DECORATOR');
export function isIdentifierDecorator(thing) {
    return thing && thing[IdentifierDecoratorSymbol] === true;
}
//# sourceMappingURL=dependencyIdentifier.js.map